import angular from 'angular';
import {
  ssDialogService,
  orgDataService
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-logo-dialog.controller';
import template from './edit-logo-dialog.html';

require('ng-file-upload');

const fileUpload = 'ngFileUpload';

require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself


export class dialogService {
  getOptions($event, {
    customerId = -1
  }) {
    return {
      controller,
      controllerAs: 'caEditCustomerLogoDialogVM',
      locals: {
        customerId
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.customerAdministration.editLogoDialog', [
  fileUpload,

  alerts,
  ssDialogService,
  orgDataService
])
  .service('editBankLogoDialog', dialogService)
  .name;

console.log('app.components.admin.customerAdministration.editLogoDialog created');
